<rt-button
  class="trigger"
  [class.trigger--expanded]="expanded()"
  variant="plain"
  size="small"
  (click)="toggle()"
>
  @if (runState() === 'running') {
    <tellent-assistant-brand-mark class="brand" />
  }
  <span class="label" [class.label--shimmer]="runState() === 'running'">
    @if (triggerLabelToolName(); as toolName) {
      {{ toolName }}…
    } @else if (triggerLabelKey(); as key) {
      {{ key | translate: { count: toolCount() } }}
    }
  </span>
  @if (hasContent()) {
    <rt-icon class="chev" name="expand-more" />
  }
</rt-button>

@if (expanded() && hasContent()) {
  <div class="timeline">
    @for (event of timeline(); track $index) {
      @switch (event.kind) {
        @case ('reasoning') {
          <tellent-assistant-text-part
            class="reasoning"
            [content]="event.content"
            [done]="event.done"
          />
        }
        @case ('tool') {
          <div
            class="row"
            [class.row--running]="event.status === 'running'"
            [class.row--error]="event.status === 'error'"
          >
            @switch (event.status) {
              @case ('done') {
                <rt-icon
                  class="ico ok"
                  name="check"
                  size="small"
                  colorToken="colorGradientAiStrongDefault"
                />
              }
              @case ('running') {
                <rt-spinner class="ico spin" variant="small-xx" />
              }
              @case ('error') {
                <rt-icon class="ico err" name="close" size="small" />
              }
            }
            <span class="name"
              >{{ toolTitles()[event.name] ?? event.name }}
              @if (event.status === 'running') {
                …
              }
            </span>
          </div>
        }
      }
    }
    @if (showThinkingShimmer()) {
      <div class="row row--thinking">
        <rt-spinner class="ico spin" variant="small-xx" />
        <span class="name label">{{
          'tlc.tellent_assistant.tool_call.thinking_status' | translate
        }}</span>
      </div>
    }
  </div>
}
